"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OldPasswordQuery = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsPassword_1 = require("../../model/hsPassword");
var service_1 = require("../../../library/base/service");
var OldPasswordQuery = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(OldPasswordQuery, _super);
    function OldPasswordQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '旧密码查询接口';
        _this.code = '105018';
        _this.desc = '旧密码查询接口';
        _this.requestParams = new hsPassword_1.OldPasswordQueryRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return OldPasswordQuery;
}(service_1.BaseService));
exports.OldPasswordQuery = OldPasswordQuery;
//# sourceMappingURL=oldPasswordQuery.js.map